const partials = new Map();
/** Fires on every change, with no payload — a listener re-reads whichever run it is showing. */
export const partialEvents = new EventTarget();
/** Publish what `runId` has written so far. An empty string CLEARS it, which is what the end of a
 *  step does once the durable message exists. */
export function setRunPartial(runId, live) {
    if (!runId)
        return;
    if (live.parts.length)
        partials.set(runId, live);
    else if (!partials.delete(runId))
        return; // nothing was there; nothing changed
    partialEvents.dispatchEvent(new Event('change'));
}
/** What `runId` is producing right now — both channels empty when it has nothing in flight. */
export function runPartial(runId) {
    return partials.get(runId) ?? EMPTY;
}
/** Shared so a caller can compare against it, and so a repaint that finds nothing allocates nothing. */
export const EMPTY = Object.freeze({ text: '', reasoning: '', tools: [], parts: [] });
/** Drop everything. For a tab that has stopped driving anything — and for tests, which must not
 *  leak one case's live text into the next. */
export function clearRunPartials() {
    if (!partials.size)
        return;
    partials.clear();
    partialEvents.dispatchEvent(new Event('change'));
}
//# sourceMappingURL=run-partials.js.map